"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
const FormGroup = ({
  className,
  children,
  inline,
  error
}) => {
  const classes = (0, _classnames.default)('FormGroup', {
    'FormGroup-inline': inline
  }, {
    'FormGroup-contains-error': error
  }, className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }, children, error);
};
var _default = exports.default = FormGroup;